import request from '@/utils/request'

export function syncData(data) {
  return request({
    url: 'api/v1/sync/syncData',
    method: 'post',
    data: data
  })
}
